import React from 'react';
import _ from 'lodash';
import { Row, Col, NavLink } from 'reactstrap';
import { toggleLoginModal as _toggleLoginModal } from 'app/shared/actions/login-modal.action';
import { logout as _logout } from 'flaivy-react/actions/auth.actions';
import { clearMyFavoriteArticles as _clearMyFavoriteArticles } from 'app/shared/actions/my-favorite-articles.action';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import StyledButton from 'flaivy-react/components/StyledButton';

const MobileUserMenu = ({
  logout,
  authentication,
  toggleLoginModal,
  asPath,
  clearMyFavoriteArticles,
  shopConfig,
}) => {
  const isAuthenticated = authentication.isAuthenticated;
  const sessionUser = authentication.sessionUser;
  const isLoggedIn = !_.isEmpty(sessionUser);
  const {
    firstName,
    lastName,
    customerSubUnit = {},
    supplierCustomer = {},
  } = sessionUser;

  const uppercaseFirstname = isAuthenticated
    ? firstName[0].toUpperCase() + firstName.substring(1)
    : null;
  const uppercaseLastname = isAuthenticated
    ? lastName[0].toUpperCase() + lastName.substring(1)
    : null;

  const activePath = decodeURI(asPath);
  const logOutUser = async () => {
    await logout();
    clearMyFavoriteArticles();
  };
  return (
    <>
      {isAuthenticated ? (
        <Col className="p-2 d-flex flex-column">
          <Row className="justify-content-center pb-2">
            <h4 className="m-0">{`${uppercaseFirstname} ${uppercaseLastname}`}</h4>
          </Row>
          <Row className="justify-content-center">
            <h6 className="text-md ">
              {customerSubUnit.name || supplierCustomer.name}
            </h6>
          </Row>
          <Row className="justify-content-center">
            <p className="text-sm ">
              Kundnummer:{' '}
              {customerSubUnit.customerNumber ||
                supplierCustomer.customerNumber}
            </p>
          </Row>
          <NavLink
            active={_.includes(activePath, 'my-favorites')}
            className="text-uppercase py-2"
            key="my-favorites"
            href="/app/my-favorites"
          >
            mina favoriter
          </NavLink>
          <Col sm={12}>
            <NavLink
              active={_.includes(activePath, 'orders')}
              className="text-uppercase py-2"
              key="orders"
              href="/app/orders"
            >
              orderhistorik
            </NavLink>
          </Col>
          <Col sm={12}>
            <NavLink
              active={_.includes(activePath, 'change-addresses')}
              className="text-uppercase py-2"
              key="change-addresses"
              href="/app/change-addresses"
            >
              företagsuppgifter
            </NavLink>
          </Col>
          {shopConfig.isSellingAlcohol && (
            <Col sm={12}>
              <NavLink
                active={_.includes(activePath, 'restaurant-report')}
                className="text-uppercase py-2"
                key="restaurant-report"
                href="/app/restaurant-report"
              >
                Volymrapport
              </NavLink>
            </Col>
          )}
          <Col sm={12}>
            <NavLink
              active={_.includes(activePath, 'change-password')}
              className="text-uppercase py-2"
              key="change-password"
              href="/app/change-password"
            >
              mina uppgifter
            </NavLink>
          </Col>
          <Col sm={12}>
            <StyledButton
              onClick={() => {
                logOutUser();
              }}
              block
              className="mt-3"
            >
              logga ut
            </StyledButton>
          </Col>
        </Col>
      ) : (
        <Col sm={12}>
          <StyledButton
            onClick={isLoggedIn ? toggleUserOffCanvas : toggleLoginModal}
            block
            className="mt-2"
          >
            logga in
          </StyledButton>
        </Col>
      )}
    </>
  );
};

const mapStateToProps = ({ authentication, shopConfig }) => ({
  authentication,
  shopConfig,
});
const mapDispatchToProps = {
  logout: _logout,
  toggleLoginModal: _toggleLoginModal,
  clearMyFavoriteArticles: _clearMyFavoriteArticles,
};
MobileUserMenu.propTypes = {
  authentication: PropTypes.object.isRequired,
  toggleLoginModal: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
  clearMyFavoriteArticles: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(MobileUserMenu);
